import { Action, Mutation, Module, VuexModule } from "vuex-module-decorators";
import { Actions, Mutations } from "@/store/enums/StoreEnums";
import ApiService from "@/core/services/ApiService";
import { AxiosRequestConfig } from "axios";


@Module
export default class DerivacionesCMModule extends VuexModule  {



  derivacioncm = {}

  derivacionescmPagination = {
    pagination: null,
    loading: true,
    error: null,
  };


  derivacionescmFilters = {
    search: "",
    page: 1,
    searchString: "",
    limit: parseInt(process.env.VUE_APP_PAGINATION || "20"),
  };

  derivacionescmFilesFilters = {
    search: "",
    page: 1,
    searchString: "",
    limit: parseInt(process.env.VUE_APP_PAGINATION || "20"),
  };




  /* --- GETTERS --- */

  get getDerivacionCm() {
    return this.derivacioncm;
  }

  get getDerivacionesCM(): any {
    return this.derivacionescmPagination;
  }

  get getDerivacionesCMPagination() {
    // //console.log('kk',this.clientsPagination);
    return this.derivacionescmPagination;
  }

  get getDerivacionesCMFilters() {
    return this.derivacionescmFilters;
  }

  get getPageDerivacionesCM() {
    return this.derivacionescmFilters.page;
  }


  /* --- MUTATIONS --- */


  @Mutation
  [Mutations.SET_DERIVACIONES_CM_PAGINATION](payload) {
    this.derivacionescmPagination = payload;
  }

  @Mutation
  [Mutations.CLEAR_DERIVACIONES_CM_FILTERS](payload) {
    this.derivacionescmFilters = {
      search: "",
      page: 1,
      searchString: "",
      limit: parseInt(process.env.VUE_APP_PAGINATION || "20"),
    };
  }
 
  @Mutation
  [Mutations.SET_PAGE_PAGINATION_DERIVACIONES_CM](payload) {
    this.derivacionescmFilters.page = payload;
  }

  @Mutation
  [Mutations.SET_DERIVACION_CM](payload) {
    this.derivacioncm = payload
  }


  @Mutation
  [Mutations.FILTER_DERIVACIONES_CM](payload) {
    // //console.log('FILTERmutation',payload);
    this.derivacionescmFilters.searchString = payload
  }



  @Action
  [Actions.CLEAR_DERIVACIONES_CM_FILTERS](payload) {
    this.context.commit(Mutations.CLEAR_DERIVACIONES_CM_FILTERS, payload);
  }

  @Action
  [Actions.SET_PAGE_PAGINATIONS_DERIVACIONES_CM](payload) {
    this.context.commit(Mutations.SET_PAGE_PAGINATION_DERIVACIONES_CM, payload.page);
    this.context.dispatch(payload.getAction);
    //console.log('SET_PAGE_PAGINATIONS_CLIENTS',payload.getAction)
  }

  @Action({ rawError: true })
  [Actions.FILTER_DERIVACIONES_CM](payload) {
    // this.context.commit(Mutations.SET_LOADING_TRUE);
    this.context.commit(Mutations.FILTER_DERIVACIONES_CM, payload);
    this.context.dispatch(Actions.GET_DERIVACIONES_CM,payload)
  }


  /* --- ACTIONS --- */

  @Action({ rawError: true })
  [Actions.DERIVATE_CM](payload) {
    const {id, tag} = payload;
   
    return new Promise((resolve, reject) => {
      ApiService.post(`/medicalcenter`, payload)
        .then(({ data }) => {
          this.context.dispatch(Actions.GET_DERIVACIONES_CM);
          resolve(data);
        })
        .catch(({ response }) => {
          reject(response.data.errors);
        });
    });
  }

  @Action({ rawError: true })
  [Actions.UPDATE_DERIVACIONES_CM_TAG](payload) {
    const {id, tag} = payload;
   
    return new Promise((resolve, reject) => {
      ApiService.put(`/medicalcenters/tag/${id}`, payload)
        .then(({ data }) => {
          this.context.dispatch(Actions.GET_DERIVACIONES_CM);
          resolve(data);
        })
        .catch(({ response }) => {
          reject(response.data.errors);
        });
    });
  }


  @Action({ rawError: true })
  [Actions.ASSIGN_DERIVACIONES_CM](payload) {
    const {id} = payload;
   
    return new Promise((resolve, reject) => {
      ApiService.put(`/medicalcenter/assign/${id}`, payload)
        .then(({ data }) => {
          this.context.dispatch(Actions.GET_DERIVACIONES_CM);
          resolve(data);
        })
        .catch(({ response }) => {
          reject(response.data.errors);
        });
    });
  }

  @Action({ rawError: true })
  [Actions.UPDATE_DERIVACIONES_CM_GROUP](payload) {
    const {id, tag} = payload;
   
    return new Promise((resolve, reject) => {
      ApiService.put(`/medicalcenter/groupcmassign/${id}`, payload)
        .then(({ data }) => {
          this.context.dispatch(Actions.GET_DERIVACIONES_CM);
          resolve(data);
        })
        .catch(({ response }) => {
          reject(response.data.errors);
        });
    });
  }

  @Action({ rawError: true })
  [Actions.DELETE_DERIVACIONCM](payload) {
    const {id} = payload;
   
    return new Promise((resolve, reject) => {
      ApiService.delete(`/medicalcenters/delete/${id}`)
        .then(({ data }) => {
          this.context.dispatch(Actions.GET_DERIVACIONES_CM);
          resolve(data);
        })
        .catch(({ response }) => {
          reject(response.data.errors);
        });
    });
  }

  



  @Action({ rawError: true })
  [Actions.GET_DERIVACIONES_CM_TO_DOWNLOAD](payload) {
    return new Promise((resolve, reject) => {
    this.derivacionescmPagination.loading = true;
     return ApiService.get(
      `medicalcenters/getallrecords?search=${this.derivacionescmFilesFilters.search}${this.derivacionescmFilesFilters.searchString}`
    )
      .then(({ data }) => {
        // //console.log('data ', data)
        // this.context.commit(Mutations.SET_CLIENTS, data);
        resolve(data)
      })
      .catch(({ response }) => {
        this.context.commit(Mutations.SET_ERROR, response.data.errors);
        reject(resolve)
      });
    })
  }



  @Action({ rawError: true })
  [Actions.GET_DERIVACIONES_CM](payload) {
    this.derivacionescmPagination.loading = true;
    return ApiService.get(
      `medicalcenters?limit=10&page=${this.derivacionescmFilters.page}&search=${this.derivacionescmFilters.search}${this.derivacionescmFilters.searchString}`
      // `customerfiles`
    )
      .then(({ data }) => {
        this.context.commit(Mutations.SET_DERIVACIONES_CM_PAGINATION, {
          pagination: data,
          loading: false,
          error: null,
        });
      })
      .catch(({ response }) => {
        this.context.commit(Mutations.SET_ERROR, response.data.errors);
      });
  }

  @Action({ rawError: true })
  [Actions.GET_DERIVACIONES_CM_BY_ID](id) {
    this.derivacionescmPagination.loading = true;
    return new Promise((resolve, reject) => {
    return ApiService.get(
      `medicalcenters/customerfilesid/${id}`
    )
      .then(({ data }) => {
        this.context.commit(Mutations.SET_DERIVACION_CM, data);
        resolve(data)
      })
      .catch(({ response }) => {
        this.context.commit(Mutations.SET_ERROR, response.data.errors);
        reject(response)
      });
    })
  }

 


}
